import { render } from "./Habits.vue?vue&type=template&id=14429573&scoped=true"
import script from "./Habits.vue?vue&type=script&lang=js"
export * from "./Habits.vue?vue&type=script&lang=js"

import "./Habits.vue?vue&type=style&index=0&id=14429573&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14429573"]])

export default __exports__